import { render, staticRenderFns } from "./wig-page-additional-properties-update-slide-out.vue?vue&type=template&id=109b2174&scoped=true"
import script from "./wig-page-additional-properties-update-slide-out.vue?vue&type=script&lang=js"
export * from "./wig-page-additional-properties-update-slide-out.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109b2174",
  null
  
)

export default component.exports